var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/utils/localStorage.ts";
import { getGlobalFilterDataKey } from "../constants";
export function getGlobalFilterFromPersist() {
  try {
    var raw = localStorage.getItem(getGlobalFilterDataKey());
    return JSON.parse(raw || '{"properties":[],"sources":[]}');
  } catch (err) {
    return {
      properties: [],
      sources: []
    };
  }
}
export function saveGlobalFilterToPersist(_ref) {
  var properties = _ref.properties,
      sources = _ref.sources;
  localStorage.setItem(getGlobalFilterDataKey(), JSON.stringify({
    sources: sources,
    properties: properties
  }));
}